﻿{
  "favoriteBoardmakerSoftware": "software Boardmaker preferito",
  "planDetailsStartTrial": "Inizia la prova gratuita oggi stesso che include l'accesso per 30 giorni!",
  "community": {
    "summary": "Sfrutta il materiale educativo accessibile e disponibile, condiviso da genitori, educatori e terapisti come te! Risparmia tempo cercando e filtrando attività e template, quindi aggiungili al tuo account e sarai pronto a modificarli e utilizzarli con il tuo software Boardmaker preferito. Con 60.000 attività di stampa e interattive GRATUITE e oltre 500.000 membri, che cosa stai aspettando?",
    "topReasons": {
      "header": "Ragioni principali per iscriverti alla myBoardmaker Community",
      "points": [
        "Condividi le fantastiche attività che hai creato",
        "Usa le potenti funzioni di ricerca per trovare esattamente ciò di cui hai bisogno",
        "Trova le attività create professionalmente dal Boardmaker Education Team",
        "Cerca attività allineate agli standard di Common Core",
        "Unisciti ai gruppi più vicini ai tuoi interessi"
      ]
    },
    "summaryEnd": "Condividi ed esplora il materiale interattivo e di stampa che fornisce supporti comportamentali e favorisce l'indipendenza degli studenti nonché le sviluppo delle abilità, tutto GRATIS.",
    "features": [
      {
        "featureTitle": "Trova",
        "featureDescription": "Scopri il curriculum adattato, le schede visive, le tabelle di comunicazione, le attività allineate agli standard educativi e altri supporti che sono stati utilizzati e sviluppati dai genitori, dai terapisti e dagli educatori."
      },
      {
        "featureTitle": "Condividi",
        "featureDescription": "Carica le attività create, partecipa ai dibattiti, stabilisci gruppi pubblici e privati per la condivisione e molto altro ancora."
      },
      {
        "featureTitle": "Utilizza",
        "featureDescription": "Archivia le attività online a accedi da qualsiasi computer."
      },
      {
        "featureTitle": "Connetti",
        "featureDescription": "Connettiti e collabora con chi, come te, sta insegnando lo stesso argomento o è al medesimo livello di classe, scambia idee con i genitori che stanno affrontando le stesse tue sfide e condividi le soluzioni che hai creato."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o successivo"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o successivo"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o successivo"]
      ],
      "browser": [
        ["Chrome", "v49.0", "attuale"],
        ["Firefox", "v38.0", "attuale"],
        ["Safari", "v11.0", "attuale"],
        ["Edge", "v83.0.478.45", "attuale"],
        ["Internet Explorer", "v10.0", "v11.0 o successivo"]
      ]
    }
  },
  "personal": {
    "summary": "Porta in casa la potenza di Boardmaker con la massima facilità. Un abbonamento myBoardmaker Personal ti offre l'opportunità di avere un ruolo attivo nel successo del tuo bambino garantendo coerenza tra casa, scuola e terapia, un'opzione per estendere l'apprendimento oltre la giornata a scuola e anche oltre l'anno scolastico. Collegati in rete con altri genitori nella Boardmaker Community per condividere le tue creazioni e scambiare idee.",
    "topReasons": {
      "header": "Ragioni principali per iscriverti a myBoardmaker Personal",
      "points": [
        "Porta attività stimolanti e interattive su qualsiasi computer o iPad",
        "Stampa attività ogni volta che ne hai bisogno",
        "Come genitore, assumi un ruolo attivo nell'apprendimento domestico del tuo bambino",
        "Scarica materiale divertente e stimolante ovunque tu vada e crea o modifica le attività da qualsiasi computer"
      ]
    },
    "summaryEnd": "Inizia la prova gratuita oggi stesso che include l'accesso completo per 30 giorni!",
    "features": [
      {
        "featureTitle": "Crea e modifica",
        "featureDescription": "Crea e modifica le attività basate su simboli, come le schede visive per pianificare la tua giornata, libri personalizzati, materiale di apprendimento e supporti comportamentali! Con una libreria di oltre 80.000 simboli dalla quale scegliere, oltre a quelli nuovi aggiunti ogni due settimane, le possibilità sono illimitate. Hai bisogno di altro? Usa la nostra opzione di ricerca nel Web per portare integrare qualsiasi file multimediale nel tuo progetto."
      },
      {
        "featureTitle": "Stampa e riproduci",
        "featureDescription": "Stampa le tue attività o quelle che trovi su Boardmaker Community direttamente dal browser Web e utilizzale con il tuo bambino. Cerchi qualcosa di più stimolante? Prova i template e le attività interattivi. I bambini e i genitori possono riprodurre facilmente le attività tramite l'app gratuita Student Center sul tablet o su un dispositivo di comunicazione."
      },
      {
        "featureTitle": "Insegna ed estendi",
        "featureDescription": "Migliora più velocemente le capacità di linguaggio e alfabetizzazione del tuo bambino accedendo ai nostri tre programmi curriculum intuitivi. Inizia con Core First Learning – uno strumento per aiutare il tuo bambino a imparare il significato, l'uso e il posizionamento delle parole principali più frequenti. Ideale per le persone che utilizzano i sistemi di comunicazione aumentativa basati sulle parole principali o per quelle che stanno imparando a leggere. Applica queste nuove abilità al livello di alfabetizzazione della classe utilizzando Book Bridge, quindi inizia a costruire la conoscenza del mondo esplorando la storia, la geografia, la vita e la cultura tramite Expedition Education."
      },
      {
        "featureTitle": "Trova e condividi",
        "featureDescription": "Perché ricreare la ruota? Scegli fra le oltre 60.000 attività GRATUITE di stampa e interattive disponibili e fra i 1.100 gruppi pubblici categorizzati nella Boardmaker Community, la più grande community di condivisione di questo tipo al mondo. Puoi anche caricare le attività create nel tuo account myBoardmaker Community e condividerle con i genitori, i terapisti o il tuo team di supporto studenti."
      },
      {
        "featureTitle": "Monitora e traccia",
        "featureDescription": "Monitora e traccia i progressi del tuo bambino man mano che lavora sulle attività per garantire il suo successo e per aiutarti a determinare l'approccio più efficace."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o successivo"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o successivo"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o successivo"]
      ],
      "browser": [
        ["Chrome", "v49.0", "attuale"],
        ["Firefox", "v38.0", "attuale"],
        ["Safari", "v11.0", "attuale"],
        ["Edge", "v83.0.478.45", "attuale"],
        ["Internet Explorer", "v10.0", "v11.0 o successivo"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional è il sistema più completo che consente agli insegnanti di educazione speciale, ai patologi della comunicazione e del linguaggio, agli ergoterapeuti, ai terapisti del comportamento, ecc. di trovare, creare, organizzare e fornire supporti visivi personalizzati, attività terapeutiche e di comunicazione basata sui simboli in base alle esigenze degli studenti in classe o in base al carico di lavoro.",
    "topReasons": {
      "header": "Ragioni principali per iscriverti a myBoardmaker Professional",
      "points": [
        "Gestisci e assegna le attività per gli studenti da qualsiasi luogo e su qualsiasi computer",
        "Utilizza l'ampia libreria di attività di esempio allineate agli standard o crea la tua",
        "Gli studenti possono accedere alle attività di apprendimento da qualsiasi computer o iPad a scuola o a casa",
        "Raccogli i dati e tieni traccia dei progressi degli studenti verso gli obiettivi IEP e gli standard educativi",
        "Gli strumenti integrati aiutano la collaborazione e la condivisione con gli altri membri del team"
      ]
    },
    "summaryEnd": "Inizia la prova gratuita oggi stesso che include l'accesso completo per 30 giorni!",
    "features": [
      {
        "featureTitle": "Crea e modifica",
        "featureDescription": "Crea e modifica le attività basate su simboli, come le schede visive per pianificare la tua giornata, libri personalizzati, materiale di apprendimento e supporti comportamentali! Con una libreria di oltre 80.000 simboli dalla quale scegliere, oltre a quelli nuovi aggiunti ogni due settimane, le possibilità sono illimitate. Hai bisogno di altro? Usa la nostra opzione di ricerca nel Web per portare integrare qualsiasi file multimediale nel tuo progetto."
      },
      {
        "featureTitle": "Stampa e riproduci",
        "featureDescription": "Stampa le tue attività o quelle che trovi su Boardmaker Community direttamente dal browser Web e utilizzale con il tuo bambino. Cerchi qualcosa di più stimolante? Prova i template e le attività interattivi. I bambini e i genitori possono riprodurre facilmente le attività tramite l'app gratuita Student Center sul tablet o su un dispositivo di comunicazione."
      },
      {
        "featureTitle": "Insegna ed estendi",
        "featureDescription": "Aiuta il tuo studente a muovere il passo successivo nel suo viaggio educativo grazie all'accesso a tre robusti programmi curriculum allineati agli standard. Incluso nel tuo abbonamento a myBoardmaker, Boardmaker Instructional Solutions offre oltre 140 opzioni di lezioni step-by-step, più di 1500 attività differenziate e allineate agli standard, 300+ libri accessibili e stampabili, strumenti di gestione classe, quiz, giochi, ricette, attività manuali e molto altro!"
      },
      {
        "featureTitle": "Trova e condividi",
        "featureDescription": "Perché ricreare la ruota? Scegli fra le oltre 60.000 attività GRATUITE di stampa e interattive disponibili e fra i 1.100 gruppi pubblici categorizzati nella Boardmaker Community, la più grande community di condivisione di questo tipo al mondo. Puoi anche caricare le attività create nel tuo account myBoardmaker Community e condividerle con i genitori, i terapisti o il tuo team di supporto studenti."
      },
      {
        "featureTitle": "Monitora e traccia",
        "featureDescription": "Monitora e traccia i progressi del tuo bambino man mano che lavora sulle attività per garantire il suo successo e per aiutarti a determinare l'approccio più efficace."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o successivo"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o successivo"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o successivo"]
      ],
      "browser": [
        ["Chrome", "v49.0", "attuale"],
        ["Firefox", "v38.0", "attuale"],
        ["Safari", "v11.0", "attuale"],
        ["Edge", "v83.0.478.45", "attuale"],
        ["Internet Explorer", "v10.0", "v11.0 o successivo"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Online Organization supporta il tuo team multidisciplinare fornendo attività personalizzate, supporti comportamentali e la misurazione dei progressi verso gli standard e gli obiettivi. \n\nIl sistema basato su cloud myBoardmaker fornisce un framework per la coerenza e la collaborazione nell'intera azienda e consente allo staff di lavorare ovunque. Inoltre, offre l'accesso a una libreria di oltre 60.000 attività già pronte, tre programmi curriculum completi e più di 80.000 Picture Communication Symbols per migliorare la pianificazione delle lezioni. Ora il tuo staff può fornire rapidamente attività di stampa e interattive agli studenti o clienti utilizzando Boardmaker Student Center per ampliare l'apprendimento e la terapia, tutto con il semplice clic di un pulsante!\n\nMonitora le prestazioni dello staff e migliora l'efficienza in tutta la tua azienda con la possibilità di gestire centralmente i dati e gli account, insieme agli strumenti avanzati di condivisione e collaborazione.",
    "topReasons": {
      "header": "Ragioni principali per iscriverti a myBoardmaker Organization",
      "points": [
        "Il sistema basato su cloud garantisce coerenza e collaborazione nell'intera azienda e consente allo staff di lavorare ovunque",
        "Ampia libreria di attività di esempio già allineate agli standard College and Career Readiness e agli standard specifici del tuo paese",
        "Gli studenti possono accedere alle attività da qualsiasi computer, ovunque",
        "Le attività possono essere associate agli obiettivi IEP per mostrare i progressi degli studenti",
        "Accesso immediato ai dati delle prestazioni degli studenti e all'uso dello staff, tutto da un unico sistema"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Crea e modifica",
        "featureDescription": "Crea e modifica le attività basate su simboli, come le schede visive per pianificare la tua giornata, libri personalizzati, materiale di apprendimento e supporti comportamentali! Con una libreria di oltre 80.000 simboli dalla quale scegliere, oltre a quelli nuovi aggiunti ogni due settimane, le possibilità sono illimitate. Hai bisogno di altro? Usa la nostra opzione di ricerca nel Web per portare integrare qualsiasi file multimediale nel tuo progetto."
      },
      {
        "featureTitle": "Stampa e riproduci",
        "featureDescription": "Stampa le tue attività o quelle che trovi su Boardmaker Community direttamente dal browser Web. Cerchi qualcosa di più stimolante? Incoraggia il team a provare i template e le attività interattivi. Gli studenti possono riprodurre facilmente le attività tramite l'app Student Center, gratuita e completamente accessibile, senza che sia necessaria una connessione Internet."
      },
      {
        "featureTitle": "Insegna ed estendi",
        "featureDescription": "Offri al tuo staff accesso ai tre robusti programmi curriculum allineati agli standard, tutti inclusi nel tuo abbonamento myBoardmaker Organization. Boardmaker Instructional Solutions offre oltre 140 opzioni di lezioni step-by-step, più di 1500 attività differenziate e allineate agli standard, 300+ libri accessibili e stampabili, strumenti di gestione classe, quiz, giochi, ricette, attività manuali e molto altro!"
      },
      {
        "featureTitle": "Assegna e monitora",
        "featureDescription": "Con un account myBoardmaker Organization, lo staff può assegnare attività personalizzate e ottimizzate a un numero illimitato di studenti per monitorare i loro progressi rispetto agli obiettivi IEP e agli standard nazionali e locali. Lo staff può quindi utilizzare il nostro strumento di Monitoraggio progressi per consultare rapidamente le prestazioni degli studenti e creare facilmente un report sui loro progressi. Anche le attività assegnate e completate a casa sono monitorate, pertanto lo staff può gestire efficacemente il lavoro a casa e collaborare con la famiglia per ampliare l'apprendimento al di fuori della classe."
      },
      {
        "featureTitle": "Trova e condividi",
        "featureDescription": "Perché ricreare la ruota? Scegli fra le oltre 60.000 attività GRATUITE di stampa e interattive disponibili e fra i 1.100 gruppi pubblici categorizzati nella Boardmaker Community, la più grande community di condivisione di questo tipo al mondo. Puoi anche caricare le attività create nel tuo account myBoardmaker Community e condividerle con i genitori, i terapisti o il tuo team di supporto studenti."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Risparmio",
        "advantagePoints": [
          "Esclusivi pacchetti aziendali personalizzati per 5+ account",
          "I servizi basati su cloud consentono la facile riassegnazione delle licenze da un membro all'altro dello staff",
          "Prezzi a volume",
          "Bundle multi-prodotto",
          "Risparmi pluriennali"
        ]
      },
      {
        "advantageTitle": "Successo per tutto",
        "advantagePoints": [
          "Le attività già pronte e basate sulla ricerca garantiscono risultati positivi e misurabili",
          "Seguendo i principi della Progettazione Universale per l'Apprendimento, le nostre attività e il nostro Materiale educativo adattato consentono alle persone con varie abilità di raggiungere i relativi obiettivi di apprendimento",
          "I curricula adattati offrono un accesso uguale per tutti",
          "Risorse disponibili con best practice avanzate per sfruttare al meglio le tue soluzioni"
        ]
      },
      {
        "advantageTitle": "Supportano standard e requisiti",
        "advantagePoints": [
          "Soluzioni studiate appositamente per l'insegnamento e la misurazione dei progressi rispetto agli standard College and Career Readiness",
          "Vasta gamma di soluzione che supportano i requisiti di Progettazione Universale per l'Apprendimento, Every Child Succeeds e Individuals with Disabilities Education Act",
          "monitora e crea automaticamente un report dei progressi rispetto agli obiettivi"
        ]
      },
      {
        "advantageTitle": "Facile distribuzione a livello aziendale",
        "advantagePoints": [
          "Consente agli amministratori di fornire e distribuire gli account in remoto in pochi secondi",
          "Opzioni di distribuzione a livello aziendale flessibili e scalabili",
          "Tutte le soluzioni basate su cloud sono contenute in un data center di livello 1 a sicurezza elevata",
          "Aggiornamenti basati su cloud gratuiti e automatici con fantastiche funzioni e risorse"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 o successivo"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o successivo"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o successivo"]
      ],
      "browser": [
        ["Chrome", "v49.0", "attuale"],
        ["Firefox", "v38.0", "attuale"],
        ["Safari", "v11.0", "attuale"],
        ["Edge", "v83.0.478.45", "attuale"],
        ["Internet Explorer", "v10.0", "v11.0 o successivo"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "Il software Boardmaker di nuova generazione è arrivato!  Boardmaker 7 racchiude tutte le migliori funzioni delle precedenti versioni di Boardmaker in un'unica appa multilingue e multi-piattaforma.  Boardmaker 7 è dotata di un'interfaccia utente ottimizzata che posiziona gli strumenti necessari a portata di mano.  Include i più recenti simboli PCS ed è, ovviamente, compatibile con tutte le precedenti schede e attività. Questo nuovo software ti consentirà di creare e fornire supporti di comunicazione e curriculum personalizzati più velocemente di prima.",
    "topReasons": {
      "header": "Ragioni principali per acquistare il software Boardmaker 7",
      "points": [
        "Modifica, stampa e riproduci tutti i tuoi precedenti file di Boardmaker",
        "Interfaccia moderna e intuitiva con suggerimenti e materiale di formazione integrati",
        "Fantastici template veloci e facili da personalizzare",
        "Trova rapidamente i simboli e le immagini di cui hai bisogno"
      ]
    },
    "summaryEnd": "Scarica oggi stesso la tua prova gratuita di 30 giorni!",
    "features": [
      {
        "featureTitle": "Apre tutto quello che hai creato",
        "featureDescription": "Non perdere tutti i tuoi anni di duro lavoro... con il software Boardmaker puoi aprire tutti i file creati con Boardmaker v5, Boardmaker v6 o Boardmaker Studio.  La conversione è rapida e precisa, quindi anche le attività interattive più complesse funzioneranno e saranno come le originali."
      },
      {
        "featureTitle": "Facile, facile, facile",
        "featureDescription": "Gli utenti si sono espressi!  Informata dai numerosi test degli utenti con persone proprio come te, l'interfaccia del software Boardmaker 7 è moderna, accogliente e intuitiva.  I suggerimenti e il materiale di formazione integrati ti garantiscono la sicurezza di esplorare, espandere le tue abilità e, più importante, di supportare i tuoi studenti."
      },
      {
        "featureTitle": "Tempi rapidi",
        "featureDescription": "Grazie ai template riprogettati sia per le attività di stampa sia per quelle intuitive, rimarrai stupefatto della vastissima gamma di tutto quello che puoi realizzare in pochi minuti.  Terminerai quella scheda o quella storia sociale in men che non si dica, avendo così più tempo da dedicare ai tuoi studenti.  Boardmaker facilita inoltre la personalizzazione delle tue creazioni, quindi puoi contare sulla combinazione ideale di velocità e flessibilità."
      },
      {
        "featureTitle": "Ricerca simboli superiori",
        "featureDescription": "I simboli ci rappresentano. Boardmaker 7 offre una funzionalità di ricerca simboli migliorata e un modo intuitivo di trovare simboli per categorie... ma questo è solo l'inizio.  Puoi cercare per porzioni di parole, parole in rima, fonemi singoli e schemi di consonanti/vocali. Questo è lo strumento di ricerca più potente disponibile!  E, se non dovessi trovare un simbolo speciale, gli strumenti della fotocamera e della ricerca Web integrati ti consentiranno di aggiungere foto in modo rapido e semplice."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 o successivo"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 o successivo"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 o successivo"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 o versioni successive"],
        ["Dispositivi Android", "Tobii Dynavox T-Series", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I-15"
        ]
      ]
    }
  }
}
